import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute, AdminRoute } from "@/components/site/ProtectedRoute";
import { SeoManager } from "@/components/site/SeoManager";
import { GoogleAnalytics } from "@/components/site/GoogleAnalytics";

import Home from "@/pages/Home";
import Store from "@/pages/Store";
import Portfolio from "@/pages/Portfolio";
import Community from "@/pages/Community";
import CourseDetail from "@/pages/CourseDetail";
import Learn from "@/pages/Learn";
import MyLearning from "@/pages/MyLearning";
import Legal from "@/pages/Legal";
import { Login, Register, ForgotPassword, ResetPassword, AuthCallback } from "@/pages/Auth";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";

import { AdminLayout } from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminCourses from "@/pages/admin/AdminCourses";
import AdminCourseEditor from "@/pages/admin/AdminCourseEditor";
import AdminHomepage from "@/pages/admin/AdminHomepage";
import AdminMedia from "@/pages/admin/AdminMedia";
import AdminStudents from "@/pages/admin/AdminStudents";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminRefunds from "@/pages/admin/AdminRefunds";
import AdminCoupons from "@/pages/admin/AdminCoupons";
import AdminCommunity from "@/pages/admin/AdminCommunity";
import AdminMessages from "@/pages/admin/AdminMessages";
import AdminWebsiteEditor from "@/pages/admin/AdminWebsiteEditor";
import AdminSettings from "@/pages/admin/AdminSettings";

function App() {
  return (
    <AuthProvider>
      <Toaster theme="dark" position="top-center" richColors />
      <BrowserRouter>
        <SeoManager />
        <GoogleAnalytics />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/store" element={<Store />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/community" element={<Community />} />
          <Route path="/course/:slug" element={<CourseDetail />} />
          <Route path="/legal/:slug" element={<Legal />} />

          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/auth/callback" element={<AuthCallback />} />

          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />

          <Route path="/learn/:courseId" element={<ProtectedRoute><Learn /></ProtectedRoute>} />
          <Route path="/my-learning" element={<ProtectedRoute><MyLearning /></ProtectedRoute>} />

          <Route path="/admin" element={<AdminRoute><AdminLayout /></AdminRoute>}>
            <Route index element={<AdminDashboard />} />
            <Route path="courses" element={<AdminCourses />} />
            <Route path="courses/:courseId" element={<AdminCourseEditor />} />
            <Route path="homepage" element={<AdminHomepage />} />
            <Route path="media" element={<AdminMedia />} />
            <Route path="students" element={<AdminStudents />} />
            <Route path="orders" element={<AdminOrders />} />
            <Route path="refunds" element={<AdminRefunds />} />
            <Route path="coupons" element={<AdminCoupons />} />
            <Route path="community" element={<AdminCommunity />} />
            <Route path="messages" element={<AdminMessages />} />
            <Route path="website" element={<AdminWebsiteEditor />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
